module.exports = __webpack_public_path__ + "img/lucky-text.3763f893.png";